<template>
	<div>
		<MessageDialog 
			:patient-list="selectedPatient"
			:show-message="newMessageDialog"
			@remove-patient="removePatient"
			@close="newMessageDialog = false"></MessageDialog>
		<ProgressBar colorType="engagement" v-if="isLoading"></ProgressBar>
		<div class="sub-head">
			<router-link :to="`/engagement/${$route.params.profileId}`">
				<i class="el-icon-back"></i>
			</router-link>
			<div class="sub-title">
				{{$route.params.eventId.replace('v0_', '').replace($route.params.profileId, '').replace(/-/g, ' ')}}
			</div>
			<span class="dot"></span>
			<div class="">
				{{ getDateRange(dateRange[0], dateRange[1])}}
			</div>
		</div>
		<div class="event-detail-body">
			<ActionCards 
				:event="event"
				:showStatus="true"
				:data="getEventCards"
				:date-range="dateRange"></ActionCards>
			<div class="select-patient" v-if="selectedPatient.length > 0">
				<span>{{selectedPatient.length}} patient{{selectedPatient.length > 1 ? 's': ''}} selected</span>
				<el-button class="message-button" @click="newMessageDialog = !newMessageDialog">Send Message</el-button>
			</div>
			<PatientTable style="margin-top: 10px" 
				:message-list="getMessageList" 
				:patient-data="getPatientData"
				@selected="onSelectPatient"></PatientTable>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ProgressBar from '@/module/component/ProgressBar'
import EventMixin from './event/mixin'

import ActionCards from './common/ActionCards'
import PatientTable from './common/PatientTable'
import MessageDialog from './common/MessageDialog'

export default {
	name: 'event-detail',
	mixins: [ EventMixin ],
	data() {
		// Setting date range from query parameters
		let dateRange = [
			this.$route.query.start ? new Date(parseInt(this.$route.query.start)) : null, 
			this.$route.query.end ? new Date(parseInt(this.$route.query.end)) : null
		]
		return {
			event: {
				id: this.$route.params.eventId
			},
			dateRange,
			selectedPatient: [],
			newMessageDialog: false,
			compareMessageId: ''
		}
	},
	created() {
		this.loadEventData({
				event: this.event.id,
				start: this.dateRange[0] ? this.dateRange[0].setHours(0,0,0,0) : null,
				end: this.dateRange[1] ? this.dateRange[1].setHours(0,0,0,0) : null
			})
	},
	computed: {
		...mapState('engagement',{
			isLoading (state) {
				return state.loading[this.event.id]
			}
		}),
		getEventCards() {
			return this.$store.getters['engagement/getEventCards'](this.event)
		},
		getMessageList() {
			return this.$store.getters['engagement/getMessageList'](this.event)
		},
		getPatientData() {
			return this.$store.getters['engagement/getPatientData'](this.event)
		}
	},
	methods: {
		...mapActions('engagement', ['loadEventData']),
		onSelectPatient(selectedPatient) {
			this.selectedPatient = selectedPatient.map(id => {
				return {
					id,
					name: this.getPatientData.find(patient => id === patient.id).given_name
				}
				
			})
		},
		removePatient(patientId) {
			this.selectedPatient =  this.selectedPatient.filter(patient => patientId !== patient.id)
		}
	},
	components: {
		ActionCards,
		PatientTable,
		MessageDialog,
		ProgressBar
	}
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
